<template>
  <button
    v-if="activeUser?.isSuperuser"
    role="switch"
    aria-label="Planningcache"
    :aria-checked="planningCacheEnabled"
    class="border-gray-lighten-2 flex w-full cursor-pointer items-center justify-between gap-3 rounded-md border-2 p-2 text-left"
    @click="togglePlanningCache"
  >
    <span>
      <span class="block font-medium">Planningcache</span>
      <span class="block text-xs opacity-70">
        Alleen deze browser. Wijzigen herlaadt de planning.
      </span>
    </span>
    <span class="font-bold">{{ planningCacheEnabled ? "Aan" : "Uit" }}</span>
  </button>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia"
import { useAuthStore } from "@/store/auth.store"
import { planningCacheEnabled } from "./recovery"

const { activeUser } = storeToRefs(useAuthStore())

function togglePlanningCache() {
  planningCacheEnabled.value = !planningCacheEnabled.value
  window.location.reload()
}
</script>
